import classes from './Maintenance.module.css';
import MaintenanceIcon from './MaintenanceIcon';
import { useTranslation } from 'react-i18next';

export default function Maintenance() {
    const { t } = useTranslation('maintenance');

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className={classes.content}>
                    <div className={classes.image}>
                        <MaintenanceIcon />
                    </div>
                    <h1 className={classes.title}>{t('title')}</h1>
                    <p className={classes.description}>{t('description-1')}</p>
                    <p className={classes.description}>{t('description-2')}</p>
                </div>
            </div>
        </div>
    );
}
